import { Building2, Contact, Settings, SlidersHorizontal, Users } from "lucide-react";
import type { NavArea } from "@optymyse/suite-ui";

/** What the person may reach: Link's settings as its Administrator, and People (SuiteUi's peopleRights). */
export type NavigationRights = { readonly administers: boolean; readonly seesPeople: boolean };

/**
 * Link's areas and their sections (Sustain's docs/SUITE_NAVIGATION_BUILD_GUIDE.html): the Directory, with its
 * customers and contacts, each a list of its own; Settings at the rail's foot, with People where Sustain has it.
 */
export function linkNavigation(rights: NavigationRights): { areas: NavArea[]; settings: NavArea } {
  return {
    areas: [
      {
        id: "directory",
        label: "Directory",
        icon: Building2,
        sections: [
          {
            id: "customers",
            label: "Customers",
            icon: Building2,
            href: "/admin/customers",
            description: "Your organisation's companies",
          },
          {
            id: "contacts",
            label: "Contacts",
            icon: Contact,
            href: "/admin/contacts",
            description: "The people at your customers",
          },
        ],
      },
    ],
    settings: {
      id: "settings",
      label: "Settings",
      icon: Settings,
      sections: [
        // General is the workspace as Optymyse holds it, for Link's Administrators; People for whoever may
        // choose who has Link, and as what.
        ...(rights.administers
          ? [
              {
                id: "general",
                label: "General",
                icon: SlidersHorizontal,
                href: "/admin/settings",
                exact: true,
                description: "The workspace, as Optymyse holds it",
              },
            ]
          : []),
        ...(rights.seesPeople
          ? [
              {
                id: "people",
                label: "People",
                icon: Users,
                href: "/admin/settings/people",
                description: "Who has Link, and invitations",
              },
            ]
          : []),
      ],
    },
  };
}
